// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyChatPlaceholder_root__KP9CU {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
}

.EmptyChatPlaceholder_content__n0F3x {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 300px;
  max-width: 100%;
}

.EmptyChatPlaceholder_title__p40d\\+ {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #272A36;
  margin-top: 16px;
  margin-bottom: 24px;
}

.EmptyChatPlaceholder_list__item__qXXHr {
  text-align: left;
  display: flex;
  align-items: flex-start;
}
.EmptyChatPlaceholder_list__item__qXXHr:not(:last-child) {
  margin-bottom: 18px;
}
.EmptyChatPlaceholder_list__item__icon__7PO8G {
  margin-right: 10px;
}
.EmptyChatPlaceholder_list__item__text__jhfUy {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #272A36;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/EmptyChatPlaceholder/EmptyChatPlaceholder.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAIE;EAKE,gBAAA;EACA,aAAA;EACA,uBAAA;AALJ;AADI;EACE,mBAAA;AAGN;AAII;EACE,kBAAA;AAFN;AAKI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHN","sourcesContent":[".root {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 0;\n}\n\n.content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  text-align: center;\n  width: 300px;\n  max-width: 100%;\n}\n\n.title {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #272A36;\n  margin-top: 16px;\n  margin-bottom: 24px;\n}\n\n.list {\n  &__item {\n    &:not(:last-child) {\n      margin-bottom: 18px;\n    }\n\n    text-align: left;\n    display: flex;\n    align-items: flex-start;\n\n    &__icon {\n      margin-right: 10px;\n    }\n\n    &__text {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 16px;\n      color: #272A36;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EmptyChatPlaceholder_root__KP9CU`,
	"content": `EmptyChatPlaceholder_content__n0F3x`,
	"title": `EmptyChatPlaceholder_title__p40d+`,
	"list__item": `EmptyChatPlaceholder_list__item__qXXHr`,
	"list__item__icon": `EmptyChatPlaceholder_list__item__icon__7PO8G`,
	"list__item__text": `EmptyChatPlaceholder_list__item__text__jhfUy`
};
export default ___CSS_LOADER_EXPORT___;
